import { ResponsivenessWrapper } from '~/components';

import * as S from './styles';

export const Loading = () => {
  return (
    <ResponsivenessWrapper>
      <S.Container>
        <S.WrapperInfo>
          <S.Column>
            <S.Spinner size={24} />
            <p>Carregando informações...</p>
          </S.Column>
        </S.WrapperInfo>
      </S.Container>
    </ResponsivenessWrapper>
  );
};
